import { Link } from '@tanstack/react-router';
import type {
  InstitutePapersSearch,
  MonitorBoardBreakdownSearch,
  MonitorInstitutesSearch,
  MonitorSubjectsSearch,
} from '../types/question.types';

export const getClassesLink = (search: MonitorBoardBreakdownSearch) => (
  <Link to="/question/monitor/classes" search={search} />
);

export const getDistrictsLink = (search: MonitorBoardBreakdownSearch) => (
  <Link to="/question/monitor/districts" search={search} />
);

export const getInstitutesLink = (search: MonitorInstitutesSearch) => (
  <Link to="/question/monitor/institutes" search={search} />
);

export const getInstitutePapersLink = (
  projectInstituteId: number,
  search: InstitutePapersSearch,
) => (
  <Link to="/question/papers/$projectInstituteId" params={{ projectInstituteId }} search={search} />
);

export const getInstituteSubjectsLink = (
  projectInstituteId: number,
  search: MonitorSubjectsSearch,
) => (
  <Link
    to="/question/monitor/institutes/$projectInstituteId"
    params={{ projectInstituteId }}
    search={search}
  />
);
